import React from 'react';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import BaseDialog, { BaseDialogProps } from '../BaseDialog';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import EcoVideo from 'eco-design/base/eco-video';

interface Dialog1Props extends BaseDialogProps {}

const Dialog1: React.FC<Dialog1Props> = (props) => {
    const { t } = useLang('theProduct.SectionJ.item1_dialog');
    return (
        <BaseDialog className={style.comp} {...props}>
            <div className="box1">
                <EcoSection title={t('item1_title')} desc={t('item1_desc')} />
                <EcoSpaceSmall />
                <div className="list">
                    <div className="item">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744767854442/JD1-1.jpg" pad="https://websiteoss.ecoflow.com/upload/image/1744767854442/JD1-1.jpg" h5="https://websiteoss.ecoflow.com/upload/image/1744876143792/1.jpg" />
                    </div>
                    <div className="item">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744767853452/JD1-2.jpg" pad="https://websiteoss.ecoflow.com/upload/image/1744767853452/JD1-2.jpg" h5="https://websiteoss.ecoflow.com/upload/image/1744876144173/2.jpg" />
                    </div>
                    <div className="item">
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744767853854/JD1-3.jpg" pad="https://websiteoss.ecoflow.com/upload/image/1744767853854/JD1-3.jpg" h5="https://websiteoss.ecoflow.com/upload/image/1744876143971/3.jpg" />
                    </div>
                </div>
            </div>
            <div className="dialog-divider"></div>
            <div className="box2">
                <EcoSection title={t('item2_title')} desc={t('item2_desc')} />
                <EcoVideo pc="https://websiteoss.ecoflow.com/upload/video/1744766701037/video4.mp4" poster='https://websiteoss.ecoflow.com/upload/image/1744874420865/fg.png' autoPlay loop />
            </div>
            <div className="dialog-divider"></div>
            <div className="box3">
                <EcoSection title={t('item3_title')} desc={t('item3_desc')} />
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744767854032/JD1-4.jpg" />
            </div>
        </BaseDialog>
    );
};
export default Dialog1;
